import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaBars, FaTimes } from "react-icons/fa";
import logo1 from "../image/logo1.png";

const Header = () => {
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isKnowledgeDropdownOpen, setIsKnowledgeDropdownOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  const navigate = useNavigate();

  const toggleDropdown = (dropdown) => {
    if (dropdown === "services") {
      setIsServicesDropdownOpen(!isServicesDropdownOpen);
      setIsKnowledgeDropdownOpen(false); // Close the other dropdown
    } else if (dropdown === "knowledge") {
      setIsKnowledgeDropdownOpen(!isKnowledgeDropdownOpen);
      setIsServicesDropdownOpen(false); // Close the other dropdown
    }
    setActiveSubMenu(null); // Close any open submenus when toggling the main dropdown
  };

  const toggleSubMenu = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };

  const handleMenuItemClick = (menuItem) => {
    // Close all dropdowns when navigating to a new page
    setIsServicesDropdownOpen(false);
    setIsKnowledgeDropdownOpen(false);
    setActiveSubMenu(null);
    setIsMobileMenuOpen(false);

    switch (menuItem) {
      case "Tax Audit":
        navigate("/TaxAdit");
        break;
      case "Statutory Audit":
        navigate("/StatutoryAudit");
        break;
      case "GST Audit":
        navigate("/GSTAudit");
        break;
      case "Internal Audit":
        navigate("/Internal");
        break;
      case "Concurrent and Statutory Bank Audit":
        navigate("/Concurry");
        break;
      case "Private Limited Company Registration":
        navigate("/Private");
        break;
      case "LLP Registration":
        navigate("/LLP");
        break;
      case "One Person Company Registration":
        navigate("/Oneperson");
        break;
      case "Partnership Registration":
        navigate("/Patnership");
        break;
      case "GST Registration":
        navigate("/GST");
        break;
      case "Udyam Registration":
        navigate("/Udyam");
        break;
      case "Import Export Code (IEC)":
        navigate("/IEC");
        break;
      case "GST Return Filing":
        navigate("/GSTReturn");
        break;
      case "Income Tax Return Filing":
        navigate("/Incometax");
        break;
      case "GST Refund Services":
        navigate("/GSTRefund");
        break;
      case "TDS & TCS Return Filing":
        navigate("/TDS");
        break;
      case "Accounting and Bookkeeping Services":
        navigate("/Acc");
        break;
      case "Knowledge":
          navigate("/Knowledge");
          break;  
      default:
        alert(`No route defined for ${menuItem}`);
    }
  };

  return (
    <>
    <header className="sticky top-0 ">
  {/* Top Bar */}
  <div className="bg-[#005A8C] text-white text-sm">
    <div className="flex flex-col md:flex-row justify-between items-center px-4 md:px-8 py-2 space-y-2 md:space-y-0">
      <p className="text-center md:text-left">
        We are open on Mon - Sat (10:00 - 18:00)
      </p>
      <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
        {/* Phone */}
        <div className="flex items-center space-x-2">
          <FaPhoneAlt />
          <span>+91 81415 14454</span>
        </div>
        {/* Email */}
        <div className="flex items-center space-x-2">
          <FaEnvelope />
          <span>kkrca@gmail.com</span>
        </div>
      </div>
    </div>
  </div>



      {/* Navigation Bar */}
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex justify-between items-center py-4">
          {/* Logo */}
          <div className="text-blue-800 font-bold text-lg">
            <img src={logo1} alt="Logo" />
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-blue-800 text-xl"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>

          {/* Navigation Links */}
          <ul
            className={`${
              isMobileMenuOpen ? "block" : "hidden"
            } md:flex space-y-4 md:space-y-0 md:space-x-6 text-gray-700 font-medium absolute md:static bg-white w-full md:w-auto left-0 top-full md:top-auto z-20 shadow-md md:shadow-none`}
          >
            <li>
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-2 md:p-0 hover:text-blue-800"
              >
                Home
              </Link>
            </li>

            {/* Dropdown Menu for Our Services */}
            <li className="relative group">
              <button
                onClick={() => toggleDropdown("services")}
                className="block w-full text-left px-4 py-2 md:p-0 hover:text-blue-800 flex items-center"
              >
                Our Services
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-4 h-4 ml-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* Dropdown */}
              {isServicesDropdownOpen && (
                <ul className="absolute bg-[#005A8C] text-white shadow-md rounded-md mt-[0.1rem] w-full md:w-[250px] z-[20] cursor-pointer left-0">
                  {[
                    {
                      title: "Auditing Services",
                      subItems: [
                        "Tax Audit",
                        "Statutory Audit",
                        "GST Audit",
                        "Internal Audit",
                        "Concurrent and Statutory Bank Audit",
                      ],
                    },
                    {
                      title: "Business Registration and License",
                      subItems: [
                        "Private Limited Company Registration",
                        "LLP Registration",
                        "One Person Company Registration",
                        "Partnership Registration",
                        "GST Registration",
                        "Udyam Registration",
                        "Import Export Code (IEC)",
                      ],
                    },
                    {
                      title: "Other Legal Compliance",
                      subItems: [
                        "GST Return Filing",
                        "Income Tax Return Filing",
                        "GST Refund Services",
                        "TDS & TCS Return Filing",
                      ],
                    },
                    {
                      title: "Accounting and Bookkeeping Services", // No sub-items
                      subItems: [],
                    },
                  ].map((item, index) => (
                    <li key={index} className="relative group">
                      {/* Main Dropdown Item */}
                      <button
                        onClick={() =>
                          item.subItems.length > 0
                            ? toggleSubMenu(index)
                            : handleMenuItemClick(item.title)
                        }
                        className={`w-full text-left px-4 py-2 hover:bg-green-500 ${
                          activeSubMenu === index ? "bg-green-500" : ""
                        }`}
                      >
                        {item.title}
                      </button>

                      {/* Submenu */}
                      {activeSubMenu === index && item.subItems.length > 0 && (
                        <ul className="absolute lg:left-full top-0  bg-white text-gray-800 shadow-lg rounded-md mt-[0.1rem]  w-[250px] z-[20]">
                          {item.subItems.map((subItem, subIndex) => (
                            <li
                              key={subIndex}
                              onClick={() => handleMenuItemClick(subItem)}
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                            >
                              {subItem}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
             {/* Dropdown Menu for Knowledge */}
             {/* <li className="relative group">
              <button
                onClick={() => toggleDropdown("knowledge")}
                className="block w-full text-left px-4 py-2 md:p-0 hover:text-blue-800 flex items-center"
              >
                Knowledge Bank */}
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-4 h-4 ml-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg> */}
              {/* </button> */}

              {/* {isKnowledgeDropdownOpen && (
                <ul className="absolute bg-blue-800 text-white shadow-md rounded-md mt-[0.1rem] w-full md:w-[250px] z-[20] cursor-pointer">
                  <li
                    className="px-4 py-2 hover:bg-green-500 cursor-pointer"
                    onClick={() => handleMenuItemClick("Startups")}
                  >
                    Startups
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-green-500 cursor-pointer"
                    onClick={() => handleMenuItemClick("RCM Basic")}
                  >
                    RCM Basic
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-green-500 cursor-pointer"
                    onClick={() => handleMenuItemClick("office managment of CA firm")}
                  >
                    office managment of CA firm
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-green-500 cursor-pointer"
                    onClick={() => handleMenuItemClick("ITR Basic")}
                  >
                    ITR Basic
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-green-500 cursor-pointer"
                    onClick={() => handleMenuItemClick("Export through E-commerce")}
                  >
                    Export through E-commerce
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-green-500 cursor-pointer"
                    onClick={() => handleMenuItemClick("Export benefits")}
                  >
                    Export benefits
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-green-500 cursor-pointer"
                    onClick={() => handleMenuItemClick("Digital Deception The Rising Tide")}
                  >
                    Digital Deception The Rising Tide 
                  </li> */}
                  <li
                    className="block px-4 py-2 md:p-0 hover:text-blue-800 cursor-pointer"
                    onClick={() => handleMenuItemClick("Knowledge")}
                  >
                    Knowledge Bank
                  </li>
                {/* </ul> */}
              {/* )} */}
            {/* </li> */}


            {/* Other Navigation Links */}
            <li>
              <Link
                to="/about"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-2 md:p-0 hover:text-blue-800"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/Career"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-2 md:p-0 hover:text-blue-800"
              >
                Career
              </Link>
            </li>
            <li>
              <Link
                to="/ContactUs"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-2 md:p-0 hover:text-blue-800"
               >
                Contact Us
                
                </Link> 
            </li>
            
              
           
            {/* Add other links here as in your original code */}
          </ul>
          
          {/* Make Appointment Button */}
          {!isMobileMenuOpen && (
            <button
              className="hidden md:block bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
              onClick={handleAppointmentClick}
            >
              Make Appointment
            </button>
          )}
          </div>


      </nav>
    </header>
    </>
  );
};

export default Header;
